// extracted by mini-css-extract-plugin
module.exports = {"link":"Item_link__3r4dA"};